import { FeatureToggle, useFeatureToggle } from "../../../utils/featureToggle";
import "./user-limit-settings.scss";

const keyToTitleMapper = {
  maxRegisteredDevices: "Maximum number of devices registration",
  maxRegisteredDevicesTimeWindow: "Number of days",
  maxLoginsPerDevice: "Maximum logins allowed per device",
  maxLoginsPerDeviceTimeWindow: "Number of days",
  maxScanCount: "Total Scan Count",
  maxScanCountTimeWindow: "Minutes",
  invalidCodeMaxAttempts: "Maximum invalid code attempts before blocking",
  invalidCodeTimeframeMinutes: "Timeframe in minutes for attempt limit",
  invalidCodeLockoutDurationMinutes:
    "Lockout period (minutes) for exceeding attempt limit",
};

export default function UserLimitCardList(props) {
  const { userSettings } = props;
  const isNewConfigEnabled = useFeatureToggle(
    FeatureToggle.enableNewConfigLimitCodeScan
  );

  return (
    <div>
      <div className="user-limit-cards-container">
        <div className="user-limit-card">
          <h4>User Device Limit Settings</h4>
          <p className="description">
            A user can login/register on maximum X devices in last Y days.
          </p>
          <div className="values-container">
            <h5>
              {keyToTitleMapper["maxRegisteredDevices"]}:
              <span>{userSettings["maxRegisteredDevices"]}</span>
            </h5>
            <h5>
              {keyToTitleMapper["maxRegisteredDevicesTimeWindow"]}:
              <span>{userSettings["maxRegisteredDevicesTimeWindow"]}</span>
            </h5>
          </div>
        </div>
        <div className="user-limit-card">
          <h4>User Login Limit Settings</h4>
          <p className="description">
            On one device, a maximum of X logins/registrations can happen in the last
            Y days.
          </p>
          <div className="values-container">
            <h5>
              {keyToTitleMapper["maxLoginsPerDevice"]} :
              <span>{userSettings["maxLoginsPerDevice"]}</span>
            </h5>
            <h5>
              {keyToTitleMapper["maxLoginsPerDeviceTimeWindow"]}:
              <span>{userSettings["maxLoginsPerDeviceTimeWindow"]}</span>
            </h5>
          </div>
        </div>
        <div className="user-limit-card">
          <h4>User Successful Code Scan Limit Settings</h4>
          <p className="description">
            {isNewConfigEnabled
              ? "A user will be blocked for Z minutes after X invalid code attempts within Y minutes."
              : "Maximum number of X code scans are allowed per user account in Y minutes."}
          </p>
          <div className="values-container">
            {!isNewConfigEnabled && (
              <>
                <h5>
                  {keyToTitleMapper["maxScanCount"]}:
                  <span>{userSettings["maxScanCount"]}</span>
                </h5>
                <h5>
                  {keyToTitleMapper["maxScanCountTimeWindow"]}:
                  <span>{userSettings["maxScanCountTimeWindow"]}</span>
                </h5>
              </>
            )}
            {isNewConfigEnabled && (
              <>
                <h5>
                  {keyToTitleMapper["invalidCodeMaxAttempts"]}:
                  <span>{userSettings["invalidCodeMaxAttempts"]}</span>
                </h5>
                <h5>
                  {keyToTitleMapper["invalidCodeTimeframeMinutes"]}:
                  <span>{userSettings["invalidCodeTimeframeMinutes"]}</span>
                </h5>
                <h5>
                  {keyToTitleMapper["invalidCodeLockoutDurationMinutes"]}:
                  <span>{userSettings["invalidCodeLockoutDurationMinutes"]}</span>
                </h5>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
